export const useTicketLists = () => {
  const actionDescriptionStore = useActionDescriptionStore()
  const inspectionDescriptionStore = useInspectionDescriptionStore()
  const malfunctionDescriptionStore = useMalfunctionDescriptionStore()

  const getDescriptionListForTicketType = (ticketType: TicketType, organization?: string): Promise<Array<ListValue>> => {
    switch (ticketType) {
      case TicketType.ACTION:
        return actionDescriptionStore.getItems(false, organization)
      case TicketType.MALFUNCTION:
        return malfunctionDescriptionStore.getItems(false, organization)
      case TicketType.INSPECTION:
      case TicketType.NEN3140:
      case TicketType.NEN1010:
        return getDescriptionListsForInspectionTicket(ticketType, organization)
      default:
        return Promise.resolve([])
    }
  }

  const getDescriptionListsForInspectionTicket = async (ticketType: TicketType, organization?: string): Promise<Array<ListValue>> => {
    const list = await inspectionDescriptionStore.getItems(false, organization)

    return list.filter((item) => !item.subtypes?.length || item.subtypes.includes(ticketType))
  }

  return {
    getDescriptionListForTicketType,
  }
}
